module.exports = __webpack_public_path__ + "img/sqlServer.188db5d5.jpg";